var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSBroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-broom",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconS-broom1",
    serifid: "iconS-broom"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.153,12.952c1.861,-1.913 5.442,-2.073 5.442,-2.073l3.423,3.398c-0,0 -0.155,3.578 -2.02,5.466c-1.865,1.883 -9.014,2.257 -9.014,2.257c0,0 0.031,-0.843 0.152,-1.95l2.792,-4.234c0.118,-0.18 -0.078,-0.396 -0.266,-0.299l-1.983,1.001c0.324,-1.487 0.794,-2.88 1.474,-3.566Zm17.542,-10.624c0.431,0.434 0.427,1.135 -0.01,1.532l-7.018,6.933l1.31,1.299c0.198,0.199 0.12,0.539 -0.148,0.627l-1.966,0.668l-3.423,-3.395l0.647,-1.943c0.09,-0.268 0.428,-0.35 0.629,-0.153l1.381,1.37l7.034,-6.948c0.436,-0.428 1.136,-0.423 1.564,0.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSBroom);
export default __webpack_public_path__ + "static/media/iconS-broom.d0d60c6c2126bfea3f7999890f637b1b.svg";
export { ForwardRef as ReactComponent };